import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintEdi_ds_get_average_weight_by_materialService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string }): 
  Promise<{ result: { SumGrossWeight?: number, SumNetWeight?: number, Count?: number, Uom?: string, PackagingId?: number, WeightUomId?: number }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { SumGrossWeight?: number, SumNetWeight?: number, Count?: number, Uom?: string, PackagingId?: number, WeightUomId?: number }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { owner_lookup?: string, project_lookup?: string, material_lookup?: string, $keys: { PackagingId?: number, WeightUomId?: number }[] }): 
  Promise<{ result: { SumGrossWeight?: number, SumNetWeight?: number, Count?: number, Uom?: string, PackagingId?: number, WeightUomId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      owner_lookup?: string, project_lookup?: string, material_lookup?: string    }) {
      return false;
    }
}
